exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".file-upload-directive-style .fileUpload {\n  position: relative;\n  overflow: hidden; }\n\n.file-upload-directive-style .fileUpload input.upload {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0; }\n\n.file-upload-directive-style .upload-btn {\n  font-size: 14px;\n  font-weight: normal;\n  border: 1px solid transparent; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/file-upload/file-upload.scss
// module id = 942
// module chunks = 1